import styled from "@emotion/styled";
import FormControl from "@mui/material/FormControl";

export const StyledFormControl = styled(FormControl)`
  height: 100%;
  width: 100%;
`;
